export default __webpack_public_path__ + "static/media/dashboardTick.a1982145.svg";